export default __webpack_public_path__ + "static/media/can-of-worms.5f215326.gif";